export class RequiredPayloadFieldIsNotProvided extends Error {
  constructor(concernedField?: string, concernedFunctionName?: string) {
    const predefinedMessage = `${concernedField} is required in payload but is not provided for ${concernedFunctionName}.`;

    super(predefinedMessage);
    this.name = 'RequiredPayloadFieldIsNotProvided';
  }
}
